export class RejectionService {
  constructor(gaApp) {
    this.gaApp = gaApp
  }

  /**
   * @param {object} opts
   * @param {string} opts.message
   * @param {string} opts.name
   * @param {unknown} opts.errorData
   * @param {string | Record<string, unknown>} [opts.userNotification] см. `notification.main.open`
   */
  log({ message, name, errorData, userNotification }) {
    try {
      const apmError = new Error(message)
      apmError.customName = name
      apmError.data = JSON.stringify(errorData)

      this.gaApp.services.app.apm.captureError(apmError)
    } catch (error) {
      const apmError = new Error(message)
      apmError.customName = name

      this.gaApp.services.app.apm.captureError(apmError)
    } finally {
      console.error(`${message}: ${errorData}`)

      if (userNotification != null && userNotification !== '') {
        this.gaApp.services.notification?.main?.open?.(userNotification)
      }
    }
  }
}
